"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _dayjs = _interopRequireDefault(require("dayjs"));
require("dayjs/locale/fr");
var _htmlDocx = _interopRequireDefault(require("html-docx-js/dist/html-docx"));
var _fileSaver = require("file-saver");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _customParseFormat = _interopRequireDefault(require("dayjs/plugin/customParseFormat"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : treatmentOccurenceList.js
* Description : Ce fichier contient la définition de la page treatmentOccurenceList 
*               Cette page liste les traitements réalisés sur un produit client
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ // <-- importe la locale
/* Hook */
_dayjs["default"].extend(_customParseFormat["default"]);

/**
* TreatmentOccurenceList : affiche la page qui liste les traitements réalisés sur un produit client
*                          un lien permet de revenir vers la page détaillé d'un traitement disponible sur produit client
*                          filtrage sur une plage de temps en entrant une date de début et de fin
*
* Type : page 
*
* Parametres : 
*  None
*/
function TreatmentOccurenceList() {
  //Define useParam
  var _useParams = (0, _reactRouterDom.useParams)(),
    equipmentId = _useParams.equipmentId,
    treatmentParamId = _useParams.treatmentParamId;

  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    treatmentParam = _useState2[0],
    setTreatmentParam = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    treatmentOccurences = _useState4[0],
    setTreatmentOccurences = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    filteredTreatmentOccurences = _useState6[0],
    setFilteredTreatmentOccurences = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    statusTreatmentOccurences = _useState8[0],
    setStatusTreatmentOccurences = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState0[0],
    setDataLoading = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    startDate = _useState10[0],
    setStartDate = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    endDate = _useState12[0],
    setEndDate = _useState12[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    applicationName = _useApi.applicationName;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function updateFilteredTreatmentOccurences() {
    // Filter with only startDate
    if (startDate !== null && endDate === null) {
      setFilteredTreatmentOccurences(treatmentOccurences.filter(function (treatment) {
        return Number(treatment.end_date.substring(0, 4)) > startDate.year() || Number(treatment.end_date.substring(0, 4)) === startDate.year() && Number(treatment.end_date.substring(5, 7)) > startDate.month() + 1 || Number(treatment.end_date.substring(0, 4)) === startDate.year() && Number(treatment.end_date.substring(5, 7)) === startDate.month() + 1 && Number(treatment.end_date.substring(8, 10)) >= startDate.date();
      }));
    }
    // Filter with only endDate
    else if (startDate === null && endDate !== null) {
      setFilteredTreatmentOccurences(treatmentOccurences.filter(function (treatment) {
        return Number(treatment.start_date.substring(0, 4)) < endDate.year() || Number(treatment.start_date.substring(0, 4)) === endDate.year() && Number(treatment.start_date.substring(5, 7)) < endDate.month() + 1 || Number(treatment.start_date.substring(0, 4)) === endDate.year() && Number(treatment.start_date.substring(5, 7)) === endDate.month() + 1 && Number(treatment.start_date.substring(8, 10)) <= endDate.date();
      }));
    }
    // Filter with startDate and endDate
    else if (startDate !== null && endDate !== null) {
      setFilteredTreatmentOccurences(treatmentOccurences.filter(function (treatment) {
        return (Number(treatment.end_date.substring(0, 4)) > startDate.year() || Number(treatment.end_date.substring(0, 4)) === startDate.year() && Number(treatment.end_date.substring(5, 7)) > startDate.month() + 1 || Number(treatment.end_date.substring(0, 4)) === startDate.year() && Number(treatment.end_date.substring(5, 7)) === startDate.month() + 1 && Number(treatment.end_date.substring(8, 10)) >= startDate.date()) && (Number(treatment.start_date.substring(0, 4)) < endDate.year() || Number(treatment.start_date.substring(0, 4)) === endDate.year() && Number(treatment.start_date.substring(5, 7)) < endDate.month() + 1 || Number(treatment.start_date.substring(0, 4)) === endDate.year() && Number(treatment.start_date.substring(5, 7)) === endDate.month() + 1 && Number(treatment.start_date.substring(8, 10)) <= endDate.date());
      }));
    }
    // No filter
    else {
      setFilteredTreatmentOccurences(treatmentOccurences);
    }
  }
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, _yield$Promise$all, _yield$Promise$all2, resTreatmentParam, resTreatmentOccurence, _yield$Promise$all3, _yield$Promise$all4, dataTreatmentParam, dataTreatmentOccurence;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Requests in parallel to win time 
            _context.n = 1;
            return Promise.all([
            // TreatmentParam
            fetch(path + "/api/eq-trpa/" + treatmentParamId + "/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            }),
            // TreatmentOccurences 
            fetch(path + "/api/eq-troc/?treatment_param_id=" + treatmentParamId, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            })]);
          case 1:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            resTreatmentParam = _yield$Promise$all2[0];
            resTreatmentOccurence = _yield$Promise$all2[1];
            _context.n = 2;
            return Promise.all([resTreatmentParam.json(), resTreatmentOccurence.json()]);
          case 2:
            _yield$Promise$all3 = _context.v;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            dataTreatmentParam = _yield$Promise$all4[0];
            dataTreatmentOccurence = _yield$Promise$all4[1];
            // Set variables
            setTreatmentParam(dataTreatmentParam);
            setStatusTreatmentOccurences(resTreatmentOccurence.ok);
            setTreatmentOccurences(dataTreatmentOccurence["results"]);
            // Dataloading
            setDataLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  var handleExport = function handleExport(event) {
    event.preventDefault();
    exportToWord();
  };
  function normalizeHtml(html) {
    var normalized_html;
    normalized_html = html.replace(/<p>/g, '<p style="margin:0;">');
    normalized_html = normalized_html.replace(/<ul>/g, '<ul style="margin:0; padding-left:20px;">');
    normalized_html = normalized_html.replace(/<ol>/g, '<ol style="margin:0; padding-left:20px;">');
    normalized_html = normalized_html.replace(/<li>/g, '<li style="margin:0;">');
    return normalized_html;
  }
  function exportToWord() {
    var report_title = "Rapport de réalisation du traitement " + treatmentParam['name'];
    var merged_phases;
    var phase_number;
    var treatment_phase_logs;
    var merged_content = "";
    filteredTreatmentOccurences.map(function (treatment) {
      return merged_phases = "", phase_number = 0, treatment_phase_logs = treatment['phase_logs'], treatment_phase_logs.map(function (phase_log) {
        return phase_number += 1, merged_phases += "\n          <p>Phase ".concat(phase_number, " : ").concat(phase_log['start_date'], " - ").concat(phase_log['end_date'], "</p>\n        ");
      }), merged_content += "\n        <h2>".concat(treatment['treatment_param']['name'], " - ").concat(treatment['start_date'], " - ").concat(treatment['end_date'], "</h2>\n        <h3>Phases de traitement :</h3>\n        ").concat(merged_phases, "\n        <h3>Notes :</h3>\n        ").concat(normalizeHtml(treatment['notes']), "\n        <p><br></p>\n      ");
    });
    var word_content = "\n      <html>\n        <head>\n          <meta charset=\"utf-8\" />\n          <style>\n            h1 { text-align: center; }\n            h3 { text-decoration: underline; }\n            p  { margin: 0; }\n          </style>\n        </head>\n        <body>\n          <h1>".concat(report_title, "</h1>\n          <p><br></p>\n          ").concat(merged_content, "\n        </body>\n      </html>\n    ");
    var blob = _htmlDocx["default"].asBlob(word_content);
    (0, _fileSaver.saveAs)(blob, "rapport.docx");
  }
  var filterReset = function filterReset(event) {
    event.preventDefault();
    setFilteredTreatmentOccurences(treatmentOccurences);
    setStartDate(null);
    setEndDate(null);
  };

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    updateFilteredTreatmentOccurences();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentOccurences, startDate, endDate]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 1
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Chargement des donn\xE9es"
        }) : statusTreatmentOccurences === true ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
            children: ["Traitements ", treatmentParam['name'], " r\xE9alis\xE9s sur le ", treatmentParam['equipment']['product']['name'], " ", treatmentParam['equipment']["serial_number"], " - ", treatmentParam['equipment']['identifier']]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex-row justify-start margin-left margin-bottom margin-top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
                path: '/treatment-params/detail/' + equipmentId + '/' + treatmentParamId,
                children: "Retour au d\xE9tail du traitement"
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: screenWidth > 650 ? 'grid-1-3' : null,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "flex-rows",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                children: "Filtres"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.DateFilter, {
                labelText: "Date de d\xE9but",
                selectedDate: startDate,
                setSelectedDate: setStartDate,
                clearable: true
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.DateFilter, {
                labelText: "Date de fin",
                selectedDate: endDate,
                setSelectedDate: setEndDate,
                clearable: true
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  onClick: filterReset,
                  className: "button-secondary clickable",
                  children: "Sans filtres"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "margin-top",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  children: "Export"
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  onClick: handleExport,
                  className: "link clickable",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: _dist.FileIcon,
                    alt: "file_icon",
                    className: "link-img"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "link-text",
                    children: "Exporter les notes des traitements s\xE9lectionn\xE9s"
                  })]
                })]
              })]
            }), screenWidth > 650 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "scroll-list-rd",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
                className: "subtitle",
                children: ["Nombre de traitements r\xE9alis\xE9s : ", filteredTreatmentOccurences.length]
              }), filteredTreatmentOccurences && filteredTreatmentOccurences.length !== 0 ? filteredTreatmentOccurences.sort(function (a, b) {
                return a.start_date > b.start_date ? 1 : -1;
              }).map(function (treatment) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ItemLink, {
                  id: treatment['id'],
                  path: "/treatment-occurences/detail/" + equipmentId + '/' + treatment['treatment_param']['id'] + '/',
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
                      className: "item-text",
                      children: [treatment['treatment_param']['name'], " - ", treatment['start_date'], " - ", treatment['end_date']]
                    })
                  })
                }, treatment['id']);
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: "Aucun traitement r\xE9alis\xE9 actuellement. Effectuer une synchronisation avec le produit client ! "
              })]
            })]
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          children: "Connexion failed"
        })
      })
    })]
  });
}
var _default = exports["default"] = TreatmentOccurenceList;